import "./Transparency.module.css";
import Header from "@/reusable_sections/Header";
import AccountabilityDashboard from "./sections/AccountabilityDashboard";
import PolicyProcedure from "./sections/PolicyProcedure";
import Footer from "@/reusable_sections/Footer";
export default function TransparencyPage() {
  return <div>
      <Header />
      <AccountabilityDashboard />
      <PolicyProcedure />
      <Footer />
    </div>;
}